<template>
    <admin-template>
        <template slot="drawers">
            <holiday-create-drawer v-model="showCreateDrawer" />

            <holiday-delete-drawer v-model="showDeleteDrawer" :item="selectedHoliday" />
        </template>

        <template slot="content">
            <v-toolbar flat dense color="transparent" height="60" class="mb-2">
                <v-toolbar-title>
                    <span class="headline">Feriados</span>
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-toolbar-title>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                fab
                                x-small
                                color="primary"
                                class="elevation-0"
                                @click.stop="onNewSelected"
                                v-on="on"
                            >
                                <v-icon>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Nuevo Feriado</span>
                    </v-tooltip>
                </v-toolbar-title>
            </v-toolbar>

            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-text>
                            <v-data-table
                                hide-default-footer
                                hide-default-header
                                :items="holidays"
                                :loading="isLoading"
                                :headers="headers"
                                :items-per-page="-1"
                                :sort-by="['date']"
                                :sort-desc="true"
                                must-sort
                            >
                                <template v-slot:item.name="{ item }">{{ item.name | capitalize }}</template>

                                <template
                                    v-slot:item.date="{ item }"
                                >{{ item.date | moment('dddd D MMMM YYYY') | capitalize }}</template>
"
                                <template v-slot:item.actions="{ item }">
                                    <v-btn icon @click.stop="onDeleteSelected(item)">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </admin-template>
</template>

<script>
import AdminTemplate from '../AdminTemplate.vue';
import HolidayCreateDrawer from '@/pages/Admin/Holidays/HolidayCreateDrawer';
import HolidayDeleteDrawer from '@/pages/Admin/Holidays/HolidayDeleteDrawer';

export default {
    components: {
        AdminTemplate,
        HolidayCreateDrawer,
        HolidayDeleteDrawer,
    },

    data() {
        return {
            showCreateDrawer: false,
            showDeleteDrawer: false,
            selectedHoliday: null,

            headers: [
                { text: 'Fecha', value: 'date' },
                { text: 'Nombre', value: 'name' },
                { text: 'Acciones', value: 'actions', align: 'end' }
            ]
        };
    },

    computed: {
        isLoading() {
            return this.$store.getters['holidays/isLoading']();
        },

        holidays() {
            return this.$store.getters['holidays/getAll']();
        }
    },

    watch: {
        showDeleteDrawer(val) {
            if (val) {
                this.showCreateDrawer = false;
            }
        },

        showCreateDrawer(val) {
            if (val) {
                this.showEditDrawer = false;
            }
        }
    },

    mounted() {
        this.$store.dispatch('holidays/fetchAll', {});
    },

    methods: {
        onNewSelected() {
            this.showCreateDrawer = true;
            this.selectedHoliday = null;
        },

        onDeleteSelected(holiday) {
            this.showDeleteDrawer = true;
            this.selectedHoliday = holiday;
        },
    }
};
</script>

<style lang="scss" scoped>
</style>
